import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { PaymentsService } from 'app/services/payments.service';
import { PrintService } from 'app/services/print.service';

@Component({
	selector: 'app-payment-run-report',
	templateUrl: './payment-run-report.component.html',
	styleUrls: ['./payment-run-report.component.scss']
})

export class PaymentRunReportComponent implements OnInit {
	color: any = false;
	currencies: any = false;
	paymentmethods: any = false;
	bankaccounts: any = false;
	reportForm: any = new UntypedFormGroup({});
	dataReady = false;
	reportdata: any = false;
	viewingForm: any;
	private lastRunPayload: any = null;



	constructor(private printService: PrintService, private globalSearchService: GlobalSearchService, private paymentsService: PaymentsService, private fb: UntypedFormBuilder) { }

	ngOnInit(): void {

		this.globalSearchService.payment_methods.subscribe((results: any) => {
			this.paymentmethods = results;
		})

		this.color = this.globalSearchService.getColor();

		this.globalSearchService.bankaccounts.subscribe((results: any) => {
			this.bankaccounts = results;
		});

		this.globalSearchService.currencies.subscribe((results: any) => {
			this.currencies = results;
		})

		this.buildForm();
	}


	runReport() {
		if (this.reportForm.valid) {
			const payload = this.buildReportPayload(this.reportForm.value);
			this.lastRunPayload = { ...payload };
			this.viewingForm = { ...this.reportForm.value };
			this.paymentsService.runPaymentReport(payload).subscribe((res) => {
				this.reportdata = res['data'];
			});
		} else {
			this.reportForm.updateValueAndValidity();
		}
	}

	formHasChangedSinceRun(): boolean {
		if (!this.lastRunPayload || !this.reportdata) return false;
		const current = this.buildReportPayload(this.reportForm.value);
		return JSON.stringify(current) !== JSON.stringify(this.lastRunPayload);
	}

	buildReportPayload(formValue: any): any {
		const { filterByDueDate, due, ...rest } = formValue;
		const payload = { ...rest, filterByDueDate: filterByDueDate !== false };
		if (payload.filterByDueDate && due != null && due !== '') {
			payload.due = due;
		}
		return payload;
	}

	buildForm() {
		this.reportForm = this.fb.group({
			fromvend: ['a', Validators.required],
			tovend: ['z', Validators.required],
			currency: ['USD', Validators.required],
			exchange: ['1', Validators.required],
			filterByDueDate: [true],
			due: ['01/31/2025', Validators.required],
			fromaccount: ['', Validators.required],
			paytype: ['', Validators.required],
		});
		this.reportForm.get('filterByDueDate')?.valueChanges.subscribe((v: boolean) => this.updateDueValidator(v));
		this.dataReady = true;
	}

	updateDueValidator(filterByDueDate: boolean): void {
		const due = this.reportForm?.get('due');
		if (!due) return;
		if (filterByDueDate) {
			due.setValidators(Validators.required);
		} else {
			due.clearValidators();
		}
		due.updateValueAndValidity({ emitEvent: false });
	}


	print() {
		const encoded: string = this.globalSearchService.base64encode(this.buildHtml());
		const data = {
			content: encoded,
			filename: 'paymentrunreport',
			title: 'Payment Run Report',
			subtitle: this.getReportSubtitle()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	exportXls() {
		const encoded: string = this.globalSearchService.base64encode(this.buildHtml());
		const filename = 'paymentrunreport.xlsx';
		const data = {
			content: encoded,
			filename,
			title: 'Payment Run Report',
			subtitle: this.getReportSubtitle()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, filename);
		});
	}

	getReportSubtitle(): string {
		if (!this.viewingForm) return 'Payment Run Report';
		return this.viewingForm['filterByDueDate'] === false
			? 'Payment Run Report – All payables'
			: `Payment Run Report for ${this.viewingForm['due']}`;
	}

	buildHtml(){
		let html = '<table style="width: 100%">'
		this.reportdata.forEach(sup => {
			//table head - reapat on page breaks
			html += '<thead>'
			html += '<tr style="background-color: black !important; color:white !important">'
			html += '<th style="text-align: left">Supplier</th>' 
			html += '<th style="text-align: right">$ Due</th>' 
			html += '<th style="text-align: right">Exchange Diff</th>' 
			html += '</tr>'

			//sup head
			html += '<tr>'
			html+= `<th style="text-align: left">${sup['supplierid']} - ${sup['name']} - ${sup['terms']}</th>`
			html += '</tr>'
			html += '</thead>'

			//details rows
			html += '<tbody>'
			sup['details'].forEach(det => {
				html += '<tr>';
				html += `<td>${det.trandate} - ${det.typename} - ${det.transno}</td>`
				html += `<td style="text-align: right">${det.balance}</td>`;
				html += `<td style="text-align: right">${det.diffonexch}</td>`;
				html += '</tr>';
			});
			html += '</tbody>'

			//sup total row
			html += '<tr style="border-top:1px solid black; border-bottom: 1px solid black">';
			html+= `<th style="text-align: left">Total due for ${sup['name']}</th>`
			html+= `<th style="text-align: right">${sup['balance']}</th>`
			html+= `<th style="text-align: right">${sup['exchTotal']}</th>`
			html+= '</tr>'
		});
		return html;
	}

	process() {
		const payload = { ...this.lastRunPayload, process: true };
		this.paymentsService.runPaymentReport(payload).subscribe((res) => {
			if (res.success) {
				this.globalSearchService.showNotification('Run Processed', 'success', 'bottom', 'left');
			}
		});
	}


}
